<template>
    <div class="creator">
        <section class="hero light-bg">
            <div class="container" id="creator">
                <div class="row align-items-center">
                    <div class="col-xl-6">
                        <div class="h1">
                            {{ $t("Tervezz, ragassz, légy egyedi!") }}
                        </div>
                        <p>
                            {{
                                $t(
                                    "Névmatrica ruhákhoz és tárgyakhoz. Mosható, vasalható. Jó tapadás."
                                )
                            }}
                        </p>
                        <p>
                            {{
                                $t(
                                    "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis."
                                )
                            }}
                        </p>
                        <p>
                            {{
                                $t(
                                    "Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis."
                                )
                            }}
                        </p>
                    </div>
                    <div class="col-xl-6">
                        <div class="row">
                            <div class="col-12">
                                <img src="/img/14.png" class="w-100 mb-4" />
                            </div>
                            <div class="col-6">
                                <img src="/img/15.png" class="w-100" />
                            </div>
                            <div class="col-6">
                                <img src="/img/16.png" class="w-100" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="loadError">
                    <div class="col-12 py-5 text-center">
                        {{ $t("A matricatervező most nem érhető el.") }}
                        <button
                            class="btn btn-simple ms-2"
                            v-on:click="getBaseData"
                        >
                            {{ $t("Újrapróbálom") }}
                        </button>
                    </div>
                </div>
                <div class="row" v-if="selectedSticker">
                    <LeftSide
                        :stickers="stickers"
                        :sticker="selectedSticker"
                        :model="model"
                        :figureHref="figureHref"
                        :backgroundHref="backgroundHref"
                        v-on:selectSticker="selectSticker"
                        v-on:update="update"
                    />
                    <div class="col-lg-6 col-xl-8">
                        <b-tabs content-class="bordered-tabs" class="pt-5" fill>
                            <b-tab :title="$t('Szöveg')">
                                <TabText
                                    :sticker="selectedSticker"
                                    :model="model"
                                    :colors="colors"
                                    :fonts="fonts"
                                    v-on:update="update"
                                />
                            </b-tab>
                            <b-tab
                                :title="$t('Minták')"
                                v-if="
                                    parseInt(selectedSticker.figure) === 1 &&
                                        model.allowedFigure
                                "
                            >
                                <TabSample
                                    :model="model"
                                    :samples="samples"
                                    v-on:update="update"
                                />
                            </b-tab>
                            <b-tab :title="$t('Hátterek')">
                                <TabBackground
                                    :allowedBackground="
                                        parseInt(selectedSticker.background) ===
                                            1 && model.allowedBackground
                                    "
                                    :model="model"
                                    :backgrounds="backgrounds"
                                    :colors="colors"
                                    :aspectRatio="aspectRatio"
                                    v-on:update="update"
                                />
                            </b-tab>
                            <b-tab
                                :title="$t('Csomag választó')"
                                v-if="parseInt(selectedSticker.package) === 1"
                            >
                                <TabPackage />
                            </b-tab>
                        </b-tabs>
                        <DownSide
                            :model="model"
                            :sticker="selectedSticker"
                            v-on:update="update"
                        />
                        <div class="text-end">
                            <strong id="sum">{{ total }} Ft</strong>
                        </div>
                        <div class="d-grid d-xl-block text-end">
                            <div
                                class="text-danger small mt-3"
                                v-if="cartError"
                            >
                                {{ cartError }}
                            </div>
                            <button
                                class="btn btn-primary my-4"
                                v-on:click="addToCart"
                                :disabled="adding"
                            >
                                <span
                                    v-if="adding"
                                    class="spinner-border spinner-border-sm me-2"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                                {{ $t("Kosárba teszem") }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="bg2">
            <div class="container">
                <div class="row">
                    <div class="col-xl-12">
                        <b-tabs
                            content-class="bordered-tabs"
                            fill
                            v-if="selectedSticker"
                        >
                            <b-tab :title="$t('Termékinformáció')" class="py-5">
                                <TabProductInfo :sticker="selectedSticker" />
                            </b-tab>
                            <b-tab :title="$t('GY.I.K. / Videó')" class="py-5">
                                <TabFaq :sticker="selectedSticker" />
                            </b-tab>
                            <b-tab :title="$t('Vélemények')" class="py-5">
                                <TabReviews :sticker="selectedSticker" />
                            </b-tab>
                        </b-tabs>
                    </div>
                </div>
            </div>
        </section>
        <section class="py-0">
            <div class="row g-0">
                <div class="col-4">
                    <img src="/img/17.png" class="w-100" />
                </div>
                <div class="col-4">
                    <img src="/img/18.png" class="w-100" />
                </div>
                <div class="col-4">
                    <img src="/img/19.png" class="w-100" />
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { notifySuccess } from "@/core/services/notify";
import LeftSide from "../components/creator/LeftSide";
import TabText from "../components/creator/tabs/TabText";
import TabSample from "../components/creator/tabs/TabSample";
import TabBackground from "../components/creator/tabs/TabBackground";
import TabPackage from "../components/creator/tabs/TabPackage";
import TabProductInfo from "../components/creator/product-tabs/TabProductInfo";
import TabFaq from "../components/creator/product-tabs/TabFaq";
import TabReviews from "../components/creator/product-tabs/TabReviews";
import DownSide from "../components/creator/DownSide";
import { getGeometry } from "@/lib/sticker/geometry";
import { stickerRows } from "@/lib/sticker/render";
import { buildPrintSvg } from "@/lib/sticker/print";
import { loadFont, missingCharacters } from "@/lib/sticker/fonts";

function luminance(hexa) {
    const hex = String(hexa || "").replace("#", "");
    const full =
        hex.length === 3
            ? hex
                  .split("")
                  .map(c => c + c)
                  .join("")
            : hex;
    const value = parseInt(full, 16);
    if (full.length !== 6 || isNaN(value)) {
        return null;
    }
    return (
        0.299 * ((value >> 16) & 255) +
        0.587 * ((value >> 8) & 255) +
        0.114 * (value & 255)
    );
}

function pickColor(colors, index, darkest) {
    if (colors[index]) {
        return colors[index].hexa;
    }
    const ranked = colors
        .filter(c => luminance(c.hexa) !== null)
        .sort((a, b) => luminance(a.hexa) - luminance(b.hexa));
    if (!ranked.length) {
        return darkest ? "#222222" : "#ffffff";
    }
    return darkest ? ranked[0].hexa : ranked[ranked.length - 1].hexa;
}

export default {
    name: "Creator",
    data() {
        return {
            model: {
                sticker: null,
                allowedFigure: true,
                allowedBackground: true,
                selectedSide: 0,
                textColor: null,
                text: ["", "", ""],
                selectedFont: null,
                sample: null,
                customFileSample: null,
                customFileBackground: null,
                background: null,
                backgroundColor: null,
                qty_textile: 0,
                qty_plastic: 0
            },
            adding: false,
            cartError: null,
            loadError: false,
            backgrounds: [],
            colors: [],
            fonts: [],
            samples: [],
            stickers: [],
            allBackgrounds: [],
            allSamples: []
        };
    },
    computed: {
        url: function() {
            return process.env.NODE_ENV === "production"
                ? `${process.env.VUE_APP_API_URL}`
                : "";
        },
        selectedSticker: function() {
            return this.stickers.find(
                element => element.sku === this.model.sticker
            );
        },
        aspectRatio() {
            return this.selectedSticker
                ? getGeometry(this.selectedSticker).aspectRatio
                : 3;
        },
        figureHref() {
            if (
                !this.selectedSticker ||
                !this.model.allowedFigure ||
                parseInt(this.selectedSticker.figure) !== 1
            ) {
                return null;
            }
            if (this.model.customFileSample) {
                return this.model.customFileSample;
            }
            const sample = this.allSamples.find(
                element => element.id === this.model.sample
            );
            return sample ? sample.image : null;
        },
        backgroundHref() {
            if (
                !this.selectedSticker ||
                !this.model.allowedBackground ||
                parseInt(this.selectedSticker.background) !== 1
            ) {
                return null;
            }
            if (this.model.customFileBackground) {
                return this.model.customFileBackground;
            }
            const background = this.allBackgrounds.find(
                element => element.id === this.model.background
            );
            return background ? background.image : null;
        },
        total() {
            if (!this.selectedSticker) {
                return 0;
            }
            return (
                this.model.qty_textile * this.selectedSticker.price_textile +
                this.model.qty_plastic * this.selectedSticker.price_plastic
            );
        }
    },
    watch: {
        "$route.query.type"(type) {
            const sticker = this.findSticker(type);
            if (sticker && sticker.sku !== this.model.sticker) {
                this.selectSticker(sticker.sku);
            }
        }
    },
    beforeMount() {
        this.getBaseData();
    },
    methods: {
        update(patch) {
            Object.keys(patch).forEach(key => {
                this.model[key] = patch[key];
            });
            this.cartError = null;
        },
        findSticker(sku) {
            const wanted = String(sku || "").toLowerCase();
            return this.stickers.find(
                element => String(element.sku).toLowerCase() === wanted
            );
        },
        selectSticker(sku) {
            const sticker = this.findSticker(sku);
            if (!sticker) {
                return;
            }
            this.model.sticker = sticker.sku;
            // Keep ?type= in sync so the current design type can be shared.
            if (this.$route.query.type !== sticker.sku) {
                this.$router
                    .replace({
                        query: { ...this.$route.query, type: sticker.sku }
                    })
                    .catch(() => {});
            }
        },
        setDemoData() {
            if (this.fonts.length) {
                this.model.selectedFont = this.fonts[0].name;
            }
            if (this.allSamples.length) {
                this.model.sample = this.allSamples[0].id;
            }
            this.model.textColor = pickColor(this.colors, 4, true);
            this.model.backgroundColor = pickColor(this.colors, 11, false);
            this.model.text = [this.$translate.t("Minta"), "", ""];

            const initial = this.findSticker(this.$route.query.type);
            this.selectSticker(initial ? initial.sku : this.stickers[0].sku);
        },
        validate() {
            const rows = stickerRows(this.selectedSticker);
            const hasText = this.model.text
                .slice(0, rows)
                .some(text => text && text.trim().length > 0);
            if (!hasText) {
                return this.$translate.t("Írj be legalább egy sor szöveget.");
            }
            const qty = this.model.qty_textile + this.model.qty_plastic;
            if (qty <= 0) {
                return this.$translate.t(
                    "Add meg a rendelni kívánt mennyiséget."
                );
            }
            const minOrder = parseInt(this.selectedSticker.min_order) || 1;
            if (qty < minOrder) {
                return (
                    this.$translate.t("Minimális rendelhető mennyiség: ") +
                    minOrder
                );
            }
            return null;
        },
        async addToCart() {
            this.cartError = this.validate();
            if (this.cartError || this.adding) {
                return;
            }
            this.adding = true;
            const uuid = localStorage.getItem("cart_uuid");
            const rows = stickerRows(this.selectedSticker);
            const design = {
                ...this.model,
                text: this.model.text
                    .slice(0, rows)
                    .map(text => (text || "").trim())
            };

            try {
                const missing = missingCharacters(
                    await loadFont(design.selectedFont),
                    design.text
                );
                if (missing.length) {
                    this.cartError =
                        this.$translate.t(
                            "A választott betűtípus nem tartalmazza ezeket a betűket:"
                        ) +
                        " " +
                        missing.join(" ");
                    return;
                }
                const printSvg = await buildPrintSvg(
                    this.selectedSticker,
                    design,
                    {
                        figure: this.figureHref,
                        background: this.backgroundHref
                    }
                );
                const response = await this.$http.put(
                    `${this.url}/cart/${uuid}`,
                    { ...design, print_svg: printSvg }
                );
                localStorage.setItem("cart_uuid", response.data.data.uuid);
                this.model.qty_plastic = 0;
                this.model.qty_textile = 0;
                this.$eventHub.$emit("updateCart", true);
                this.$eventHub.$emit("openCart");
                notifySuccess(this.$translate.t("A matrica a kosárba került."));
            } catch (e) {
                // API errors are shown as toasts by the api service.
            } finally {
                this.adding = false;
            }
        },
        getBaseData() {
            const self = this;
            self.loadError = false;
            self.$http
                .get(`${self.url}/sticker/get-data`)
                .then(response => {
                    self.backgrounds = response.data.backgrounds;
                    self.colors = response.data.colors;
                    self.fonts = response.data.fonts;
                    self.samples = response.data.samples;
                    self.stickers = response.data.stickers;
                    self.allBackgrounds = response.data.all_backgrounds;
                    self.allSamples = response.data.all_samples;
                    if (self.stickers.length) {
                        self.setDemoData();
                    }
                })
                .catch(() => {
                    self.loadError = true;
                });
        }
    },
    components: {
        DownSide,
        TabReviews,
        TabFaq,
        TabProductInfo,
        TabPackage,
        TabBackground,
        TabSample,
        TabText,
        LeftSide
    }
};
</script>

<style scoped></style>
